module.exports = __webpack_public_path__ + "static/media/retention.beb3f7c5.svg";